import React from 'react';
import './ServicesSection.css';


const ServicesSection = () => (
  <section className="services" id="services" aria-label="VTD Astrology services">
    <div className="services__inner">
      <div className="services__header">
        <p className="section-eyebrow">Connect With Us</p>
        <h2 className="section-title">Ready for Your Reading?</h2>
        <p className="section-sub">Chat with Tilak directly for personalized Vedic guidance</p>
        <div className="gold-divider" />
      </div>

      <div className="services__single-cta">
        <div className="chat-card">
          <div className="chat-card__icon">
            <ChatIcon />
          </div>
          <h3 className="chat-card__title">Start Your Journey</h3>
          <p className="chat-card__desc">
            Get authentic Vedic readings covering past predictions, future insights,
            tarot, palmistry, numerology, vastu, and personalized remedies — all in one chat.
          </p>
          <a href="/chat" className="chat-card__btn">
            Chat with Tilak Now →
          </a>
        </div>
      </div>
    </div>
  </section>
);

function ChatIcon() {
  return (
    <svg viewBox="0 0 64 64" width="60" height="60" fill="none" stroke="#D4AF37" strokeWidth="2" strokeLinecap="round">
      <path d="M32 8 C46 8 56 18 56 32 C56 46 46 56 32 56 L16 56 L8 48 L8 32 C8 18 18 8 32 8 Z"/>
      <circle cx="24" cy="28" r="2" fill="#FFD700" stroke="none"/>
      <circle cx="32" cy="28" r="2" fill="#FFD700" stroke="none"/>
      <circle cx="40" cy="28" r="2" fill="#FFD700" stroke="none"/>
      <path d="M20 36 Q32 44 44 36" stroke="#FFD700" strokeWidth="1.5"/>
    </svg>
  );
}

export default ServicesSection;
